import FuseUtils from '@fuse/utils';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import authService from 'app/services/authService';
import * as Actions from 'app/store/actions';
import { getTenant } from 'app/utils/enviromentUtil';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FuseNavBadge from '../FuseNavBadge';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 48,
    '&.active': {
      // backgroundColor: theme.palette.primary.main,
      // color: `${theme.palette.primary.contrastText}!important`,
      // pointerEvents: 'none',
      '& .list-item-text-primary': {
        color: 'inherit',
      },
      '& .list-item-icon': {
        color: 'inherit',
      },
    },
    '& .list-item-icon': {},
    '& .list-item-text': {
      padding: '0 0 0 16px',
    },
    color: theme.palette.text.primary,
    textDecoration: 'none!important',
  },
}));

function FuseNavHorizontalItem(props) {
  const dispatch = useDispatch();
  const userRole = useSelector(({ auth }) => auth.user.role);

  const classes = useStyles(props);
  const { item } = props;
  const { t } = useTranslation('navigation');
  const history = useHistory();

  if (!FuseUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  const CustomIcon = item.icon;

  const tenant = getTenant();
  const showItem =
    item.id !== 'acompanhar_regua_cobranca' ||
    !process.env.REACT_APP_TENANT_FATUREMAIS ||
    tenant === process.env.REACT_APP_TENANT_FATUREMAIS;

  return (
    showItem && (
      <ListItem
        button={true}
        // component={NavLinkAdapter}
        // to={item.url}
        activeclassname="active"
        className={clsx('list-item', classes.root)}
        onClick={(ev) => {
          if (authService.hasAuthority(item.authority)) {
            history.push(item.url, { id: item.id });
            dispatch(Actions.navbarCloseMobile());
          } else {
            dispatch(
              Actions.showMessage({ message: 'Você não possui permissão para acessar esta tela.', variant: 'error' })
            );
          }
        }}
        exact={item.exact ? item.exact : false}
      >
        {item.icon && typeof item.icon === 'string' ? (
          <Icon className="list-item-icon text-16 flex-shrink-0" color="action">
            {item.icon}
          </Icon>
        ) : (
          <CustomIcon size={14} color="#fff" />
        )}

        <ListItemText
          className="list-item-text"
          primary={item.translate ? t(item.translate) : item.title}
          classes={{ primary: 'text-14 list-item-text-primary' }}
        />

        {item.badge && <FuseNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
      </ListItem>
    )
  );
}

FuseNavHorizontalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

FuseNavHorizontalItem.defaultProps = {};

const NavHorizontalItem = React.memo(FuseNavHorizontalItem);

export default NavHorizontalItem;
